module.exports = __webpack_public_path__ + "img/commander12.png";